import { useEffect, useState } from "react";
import { ACTION_KEY, ACTION_SELECTED_ID_KEY, PARENT_ID_KEY } from "../config";
import {
  CRUDAction,
  CrudItems,
  CrudOptions,
} from "../components/Category/CrudMenu";
import { useDispatch, useSelector } from "react-redux";
import {
  selectActionID,
  selectActionKey,
  setActionID,
  setActionKey,
} from "reducers/redirect";

export const useHandleActionFromStorage = <Data>(
  menuItems: CrudItems<Data, CrudOptions>,
  selectedId: React.ReactText | null,
  fromRowOption: boolean,
  dispatch: React.Dispatch<CRUDAction>,
  setTestRedirected?: React.Dispatch<
    React.SetStateAction<boolean | null | undefined>
  >
) => {
  const dispatch_general = useDispatch();
  const actionKey = useSelector(selectActionKey);
  const actionID = useSelector(selectActionID);
  const [redirected, setRedirected] = useState<boolean | null>();
  useEffect(() => {
    const action = window.localStorage.getItem(ACTION_KEY) ?? actionKey;
    const parentID = window.localStorage.getItem(PARENT_ID_KEY);
    let finalSelectedId = selectedId;
    if (!action || !menuItems) {
      setRedirected(false);
      return;
    }

    const storageSelectedId: string | null =
      window.localStorage.getItem(ACTION_SELECTED_ID_KEY) ?? actionID ?? null;

    if (storageSelectedId && typeof storageSelectedId === "string") {
      finalSelectedId = parseInt(storageSelectedId);
    }

    setRedirected(true);
    setTestRedirected && setTestRedirected(true);

    if (finalSelectedId && action) {
      dispatch({
        type: "change_open_menu",
        payload: {
          crudOptions: action as CrudOptions,
          selectedId: finalSelectedId,
          fromRowOption: fromRowOption
            ? fromRowOption
            : finalSelectedId
            ? true
            : false,
        },
      });
    }

    dispatch_general(setActionID(null));
    dispatch_general(setActionKey(null));

    if (!parentID) {
      window.localStorage.removeItem(ACTION_KEY);
      window.localStorage.removeItem(ACTION_SELECTED_ID_KEY);
    }

    // window.localStorage.removeItem(ACTION_SELECTED_ID_KEY);
  }, []);
  // }, [menuItems]); // NOTE: Commented this out as it caused the currentMenu to reset in the store when the menuItems changed. This meant that when redirecting and auto-opening a menu, it would sometimes not open the menu. So changed to just [] (initial render)

  return redirected;
};
